import { WSMessageEvent } from '../types/WSMessageBody';

export const USER_CONNECTION: WSMessageEvent = 'userConnection';
export const CHAT_MESSAGE = 'chatMessage';
export const SET_GAME_STATE = 'setGameState';
export const INIT_MESSAGE = 'initMessage';
export const ERROR = 'error';
export const VOTE = 'vote';
export const CHOOSE_CARD = 'chooseCard';
